enum TiposMovimentacaoEstoque {
    Entrada = 1,
    Saida = 2,
    Transferencia = 3
}

export default TiposMovimentacaoEstoque;